//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Anchor from '@components/atoms/anchor/Anchor';
import { BodyText } from '@components/atoms/text/Text';
import booksImage from '@images/your-resources.svg';
import { OnboardingInfoCard } from '@welcome-page/components/onboarding/info/OnboardingInfoCard';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

export const OnboardingResourcesCard = () => {
  return (
    <StyledInfoCard
      icon={<BookImage alt='' src={booksImage} />}
      title='Resources'
    >
      <ResourceList>
        <li>
          <BodyText>
            Read our{' '}
            <ResourceAnchor
              href='https://docs.bazaarvoice.com/articles/vibe/get-started-with-vibe'
              trackingId={
                ONBOARDING_TRACKING_ID.RESOURCES_GETTING_STARTED_ARTICLE_ANCHOR
              }
            >
              getting started article
            </ResourceAnchor>
          </BodyText>
        </li>
        <li>
          <BodyText>
            Visit our{' '}
            <ResourceAnchor
              href='https://docs.bazaarvoice.com/articles/vibe/vibe'
              trackingId={
                ONBOARDING_TRACKING_ID.RESOURCES_KNOWLEDGE_BASE_ANCHOR
              }
            >
              Knowledge Base
            </ResourceAnchor>
          </BodyText>
        </li>
        <li>
          <BodyText>
            Get started with your Vibe strategy in&nbsp;
            <ResourceAnchor
              href='https://bazaarvoice-university.northpass.com/p/d6e2a69e1e971d68cc4e5082572f8694e50feae5'
              trackingId={
                ONBOARDING_TRACKING_ID.RESOURCES_OVERVIEW_BAZAARVOICE_UNIVERSITY_LINK
              }
            >
              Bazaarvoice University
            </ResourceAnchor>
          </BodyText>
        </li>
      </ResourceList>
    </StyledInfoCard>
  );
};

const StyledInfoCard = styled(OnboardingInfoCard)(
  ({ theme }) => `
  gap: ${theme.spacings[5]};
`,
);

// These are specific sizes just for this image from design
const BookImage = styled.img`
  height: 71px;
  width: 103px;
`;

const ResourceList = styled.ul(
  ({ theme }) => `
  list-style-position: outside;
  padding-left: ${theme.spacings[4]}
`,
);

const ResourceAnchor = styled(Anchor).attrs({ target: '_blank' })(
  ({ theme }) => `
  &&, &&:hover {
    color: ${theme.colors.teal2};
  }
`,
);
